import type { ComponentChildren, FunctionalComponent } from 'preact';

import { cnButton } from './button.constants.js';

import './button.css';

type BlockAttributes = {
    href: string;
    mode: 'light' | 'dark';
    className?: string;
    children: ComponentChildren;
    autoFocus?: boolean;
    onClick?: VoidFunction;
    target?: '_blank' | '_self' | '_top' | '_parent';
    id?: string;
};

export interface ButtonProps extends BlockAttributes {}

export const Button: FunctionalComponent<ButtonProps> = ({ mode, className, children, ...restProps }) => (
    <a className={cnButton({ mode }, [className])} {...restProps}>
        {children}
    </a>
);
